import React, { useContext, useEffect, useState } from "react";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import SectionHeader from "../components/section/SectionHeader";
import InfoAlert from "../ui/InfoAlert";
import OrgContext from "../store/orgContext";
import InlineLoader from "../components/loader/InlineLoader";
import NewDFSIGroup from "../components/dfsi/groups/NewDFSIGroup";
import { makeApiRequest } from "../util";
import AuthContext from "../store/authContext";
import {
  CREATE_DFSI_GROUP_TRANSLATIONS,
  LOADING_TEXT_TRANSLATIONS,
} from "../translations/util";

const NewDFSIGroups = () => {
  const { token } = useContext(AuthContext);
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);
  const [iwfId, setIwfID] = useState<string>();

  const getIWFId = async (orgId: string) => {
    try {
      const response = await makeApiRequest<{
        "IWF-ID": string;
      }>({
        path: `/api/v1/app-config/mappings/${orgId}`,
        token,
        org: orgId,
      });
      setIwfID(response["IWF-ID"]);
      // setConnectionIds(response.Rows.map((row) => row["CONNECTION-ID"]));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      // errorAlert(e);
    }
  };

  useEffect(() => {
    if (selectedOrg) getIWFId(selectedOrg?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrg]);

  if (!orgList || orgList.length === 0) {
    return (
      <InlineLoader
        description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
      />
    );
  }

  return (
    <>
      <SectionHeader
        pageTitle={CREATE_DFSI_GROUP_TRANSLATIONS.header}
        pageDescription={CREATE_DFSI_GROUP_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              disabled
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />

      <div className="main-content">
        {!selectedOrg ? (
          <InfoAlert
            heading={
              CREATE_DFSI_GROUP_TRANSLATIONS.infoAlert.missingOrg.heading
            }
            subText={
              CREATE_DFSI_GROUP_TRANSLATIONS.infoAlert.missingOrg.subText
            }
          />
        ) : null}

        {selectedOrg && !iwfId ? (
          <InfoAlert
            heading={
              CREATE_DFSI_GROUP_TRANSLATIONS.infoAlert.missingIWF.heading
            }
            subText={
              CREATE_DFSI_GROUP_TRANSLATIONS.infoAlert.missingIWF.subText
            }
          />
        ) : null}

        {selectedOrg && iwfId ? (
          <NewDFSIGroup org={selectedOrg.id} iwfId={iwfId} />
        ) : null}
      </div>
    </>
  );
};

export default NewDFSIGroups;
